import React, { useEffect, useRef, useState } from "react";
import Info from "../components/Info";
import axiosInstance from '../api/axiosInstance'
import "../assets/css/home.css";
import { useNavigate } from "react-router-dom";
import Header from "../components/Header";
import Modal from "../components/Modal";
import SnthsHstry from "./popup/SnthsHstry";
import RightMenuPanel from "../components/RightMenuPanel";
import NtfcPopup from "./popup/NtfcPopup";

const Home = () => {
  const [sideMenuItems, setSideMenuItems] = useState([]);
  const [isHstryModalOpen, setIsHstryModalOpen] = useState(false);
  const [isNtfcModalOpen, setIsNtfcModalOpen] = useState(false);
  const [searchParam, setSearchParam] = useState([]);
  const [searchValue, setSearchValue] = useState(null);
  const [sidebarHovered, setSidebarHovered] = useState(false);
  const [categoryTag, setCategoryTag] = useState();
  
  const iconRef  = useRef(null);

  const navigate = useNavigate();

  // 헤더에서 접근할 수 있게 prop 전달
  // 종합 이력 조회 팝업 - 열기
  const openSnthsHstryModal = () => {
    setIsHstryModalOpen(true);
  };
  // 종합 이력 조회 팝업 - 닫기
  const closeSnthsHstryModal = () => {
    setIsHstryModalOpen(false);
  };
  
  // 알림 팝업 - 닫기
  const closeNtfcPopupModal = () => {
    setIsNtfcModalOpen(false);
  };

  // 알림 팝업 - 토글
  const toggleNtfcPopupModal = () => {
    setIsNtfcModalOpen(prev => !prev);
  };

  const componentMap = {
    ALL: "전체",   
    G: "그리드",   
    Z: "구그리드", 
    C: "컴포넌트", 
    D: "데이터 셋",
    E: "기타",     
    F: "함수",     
    U: "공통 모듈",
  };


  useEffect(() => {
    axiosInstance
      .get("/common/findMenu")
      .then((res) => {
        const iconMap = {
          G: "icon-grid",     // 그리드
          Z: "icon-grid",     // 구그리드
          C: "icon-comp",     // 컴포넌트
          D: "icon-dataset",  // 데이터 셋
          E: "icon-etc",      // 기타
          F: "icon-fn",       // 함수
          U: "icon-common"    // 공통 모듈
        };

        const mapped = res.data.map((item) => ({
          label: item.KOR_FMY_NM,
          code: item.DETAIL_CODE,
          sideMenuIcon: iconMap[item.DETAIL_CODE] || "icon-doc"
        }));

        setSideMenuItems(mapped);
      })
      .catch((err) => {
        console.error("메뉴 불러오기 실패:", err);
      });
  }, []);

  useEffect(() => {
    if (!searchParam) return;
    
    const controller = new AbortController(); // ← 추가
    const fetchSearchResult = async () => {
      try {
        const res = await axiosInstance.get("/info/search", {
          signal: controller.signal,
          params: {
            ARTCL_CD_UNQ_VL: searchParam.category === "ALL" ? "" : searchParam.category,
            ARTCL_NM: searchParam.keyword || "",
            ATRB_NM: searchParam.keyword || "",
          }
        });
  
        setCategoryTag(
          <>
            <h3 style={{ margin: 0 }}>sFrame</h3>
            <h3 style={{ margin: 0 }}>·</h3>
            <span>
              {searchParam?.category === "ALL"
                ? "전체"
                : componentMap[searchParam?.category] || searchParam?.category}
            </span>
          </>
        );
        setSearchValue(res.data);
      } catch (err) {
        if (err.name !== "CanceledError") {
          console.error("검색 실패:", err);
        }
      }
    };
  
    fetchSearchResult();
    return () => controller.abort(); // ← 컴포넌트 unmount 또는 새 요청 시 취소
  }, [searchParam]);

  return (
    <>
      <Header
        searchParam={searchParam}
        onOpenSnthsHstry={openSnthsHstryModal}
        onOpenNtfcPopup={toggleNtfcPopupModal}
        onChange={(param) => {
          setSearchParam(param);
        }}
        ntfcIconRef={iconRef}
      />
      
      <div className={"layout-container"}>
      <aside
          className="sidebar group relative transition-all duration-300 overflow-hidden before:content-[''] before:z-[-1] before:w-full before:h-full before:absolute before:top-0 before:left-0 before:bg-texture-black before:bg-contain before:bg-no-repeat"
          onMouseEnter={() => setSidebarHovered(true)}
          onMouseLeave={() => setSidebarHovered(false)}
          style={{
            backgroundColor: sidebarHovered ? 'rgba(255,255,255,0.7)' : 'transparent',
            width: sidebarHovered ? '220px' : '80px',
          }}
        >
          <a className="relative flex items-center h-[65px] px-5 transition-all duration-300">
            {/* 로고+텍스트 묶음 */}
            {/* <div
              className="flex items-center transition-all duration-300"
              style={{
                position: sidebarHovered ? 'static' : 'absolute',
                left: sidebarHovered ? 'auto' : '50%',
                transform: sidebarHovered ? 'none' : 'translateX(-50%)',
              }}
              // onClick={() => navigate('/')}
              onClick={() => window.location.reload()}
            > */}
            <div className="flex items-center"
                 onClick={() => window.location.reload()}
            >
              {/* 아이콘 */}
              <div className="flex items-center cursor-pointer">
                <div
                  className="flex h-[34px] w-[34px] items-center justify-center rounded-lg bg-gradient-to-r from-theme-1 to-theme-2"
                  style={{
                    transition: 'transform 0.1s ease-in-out',
                    transform: sidebarHovered ? 'rotate(-180deg) scale(1.1)' : 'rotate(0deg) scale(1)',
                  }}
                >
                  <div className="relative h-[16px] w-[16px] -rotate-45 [&_div]:bg-white">
                    <div className="absolute inset-y-0 left-0 my-auto h-[75%] w-[21%] rounded-full opacity-50"></div>
                    <div className="absolute inset-0 m-auto h-[120%] w-[21%] rounded-full"></div>
                    <div className="absolute inset-y-0 right-0 my-auto h-[75%] w-[21%] rounded-full opacity-50"></div>
                  </div>
                </div>
              </div>

              {/* 글자 */}
              <div
                className={`overflow-hidden whitespace-nowrap ${
                  sidebarHovered ? 'ml-3.5 w-auto opacity-100' : 'ml-0 w-0 opacity-0'
                }`}
              >
                Document
              </div>
            </div>
          </a>

          <div className="relative z-10 mt-2 hidden flex-none items-center overflow-hidden px-5 duration-300 xl:flex group-[.side-menu--collapsed.side-menu--on-hover]:xl:w-[275px] group-[.side-menu--collapsed]:xl:w-[91px]">
            {/* 사이드 메뉴바 */}
            <ul className="bg-transparent">
              {sideMenuItems.map((item, idx) => (
                <li className={"sideMenu bg-transparent"} key={idx} onClick={() =>
                  setSearchParam((prev) => ({
                    ...prev,
                    category: item.code,
                    keyword:""
                  }))
                }>
                  <span className={"icon"}>
                    <a className={item.sideMenuIcon}></a>
                  </span>
                  <span className={"label"}>{item.label}</span>
                </li>
              ))}
            </ul>
          </div>
        </aside>
      
        <main 
          className="main-content shuriken before:content-[''] before:z-[-1] before:w-screen before:h-screen before:bg-slate-50 before:top-0 before:fixed before:bg-texture-black before:bg-contain before:bg-fixed before:bg-[center_-20rem] before:bg-no-repeat"
          style={{ display: 'flex', gap: '24px', position: 'relative' }}
        >
        <div className="w-[1000px] mx-auto flex gap-6">
            <div className="card-container" >
              <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '20px' }}>
                {categoryTag}
              </label>
              {searchValue ? (
                <Info searchValue={searchValue} />
              ) : (
                <></>
              )}
          </div>
          {searchValue ? (
            <RightMenuPanel
              searchValue={searchValue}
              onSelect={(item) => {
                // console.log(`[${selectedLabel}] 선택된 항목:`, item);
              }}
            ></RightMenuPanel>
            ) : (
              <></>
            )}
          </div>
        </main>
      </div>
      
      {/* 종합 이력 조회 팝업 */}
      {isHstryModalOpen && (
        <Modal onClose={closeSnthsHstryModal}>
          <SnthsHstry />
        </Modal>
      )}

      {/* 알림 팝업 */}
      {isNtfcModalOpen && (
        <NtfcPopup onClose={closeNtfcPopupModal} anchorRef={iconRef} />
      )}
    </>
  );
};

export default Home;
